import React, {createContext, useContext, useEffect, useReducer} from "react";
import {useLocation} from "react-router-dom";
import {getStepById} from "../utils/stepsConfig";
import {plans} from "../config/payment";
import {trackStepView} from "../utils/analytics";

const FunnelContext = createContext();

const initialState = {
    currentStep: 0,
    measurementSystem: "metric",
    navigationDirection: "forward",
    userData: {
        focus: "",
        focuses: [],
        gender: null,
        birthday: null,
        height: null,
        weight: null,
        activityLevel: null,
        goal: null,
        dietaryPreferences: [],
        weightGoal: null,
        trainingActivity: null,
        workoutFrequency: null,
        walkingFrequency: null,
        healthConcerns: [],
        snackCravings: null,
        emotionalEating: null,
        eatingHabits: null,
        plateClearing: null,
        routinePersistence: null,
        mealPreferences: null,
        carbFrequency: null,
        produceIntake: null,
        diet_plan: null,
        food_restrictions: null,
        busyness_level: null,
        meal_preparation: null,
        cookingSkill: null,
        weight_loss_knowledge: null,
        calorie_knowledge: null,
        eating_improvement: null,
        food_tracking: null,
        nutrient_tracking: null,
        weight_loss_diet_knowledge: null,
        wrong_food_worry: null,
        unhealthy_decisions_spiral: null,
        email: "default@caloria.tech",
        selectedPlan: plans[0],
    },
};

function funnelReducer(state, action) {
    switch (action.type) {
        case "SET_STEP":
            return {
                ...state,
                currentStep: action.payload,
            };
        case "UPDATE_USER_DATA":
            return {
                ...state,
                userData: {...state.userData, [action.field]: action.value},
            };
        case "SET_MEASUREMENT_SYSTEM":
            return {
                ...state,
                measurementSystem: action.payload,
            };
        case "INITIALIZE_MEASUREMENT_SYSTEM":
            return {
                ...state,
                measurementSystem: action.payload,
            };
        default:
            return state;
    }
}

export function FunnelProvider({children}) {
    const [state, dispatch] = useReducer(funnelReducer, initialState);
    const location = useLocation();

    // Track step views
    useEffect(() => {
        if (typeof state.currentStep === "number") {
            trackStepView(state.currentStep);
        }
    }, [state.currentStep]);

    // Initialize step from URL
    useEffect(() => {
        const pathMatch = location.pathname.match(/\/step\/([^/]+)/);
        if (pathMatch) {
            const stepId = pathMatch[1];
            const stepIndex = getStepById(stepId);
            if (stepIndex !== -1) {
                dispatch({
                    type: "SET_STEP",
                    payload: stepIndex,
                });
            }
        }
    }, [location]);

    return (
        <FunnelContext.Provider value={{state, dispatch}}>
            {children}
        </FunnelContext.Provider>
    );
}

export const useFunnel = () => useContext(FunnelContext);
